// extracted by mini-css-extract-plugin
export default {"tabContent":"TimeClockDetail_tabContent__R4gpD","tabItem":"TimeClockDetail_tabItem__Ae6ah"};